import React from 'react';

export const TablePreloader = ({ colSpan }) => (
  <tr className="table_row with_spiner">
    <th colSpan={colSpan} style={{ textAlign: 'center' }}>
      <div className="table-loader">
        <div className="loader" />
      </div>
    </th>
  </tr>
);

export const FullPreloader = () => (
  <div
    className="page-loader"
    style={{ position: 'fixed', top: 0, left: 0, zIndex: 10000 }}
  >
    <div className="loader" />
  </div>
);

export const SmallPreloader = () => (
  <div style={{ height: '100%' }}>
    <div className="table-loader">
      <div className="loader" />
    </div>
  </div>
);
